'use strict';

import React, {Component} from 'react';
import PropTypes from "prop-types";
import {observer} from "mobx-react";
import classnames from "classnames";

import Form from 'react-bootstrap/Form';
import Button from "react-bootstrap/Button";

import optionalChargesStore from "./OptionalChargesStore";
import {Campus} from '@uw-it-sis/lib-react/lib/AppConstants';

class OpChargeWashPIRG extends Component {
    constructor(props) {
        super(props);
        this.props = props;

        this.store = optionalChargesStore;
    }

    handleChange = (e) => {
        const {name, value} = e.target;
        this.store.updateFormData(name, value);
    }

    submitForm = (e) => {
        e.preventDefault();
        this.props.onSuccess();
    }

    render() {
        const campus = this.props.campus;
        const data = this.store.data;
        const formData = this.store.formData;

        if (campus !== Campus.seattle) {
            return null;
        } else {
            const isUpdatable = (data.wpg_update_sw === "Y");
            const amount = Number(data.washpirg_amt) > 0 ? Number(data.washpirg_amt).toFixed(2) : "3.00"; //...default amount if the charge is not in the SDB tables yet

            let form;
            if (! isUpdatable) {
                let nextButton;
                if (this.props.showButton) {
                    nextButton = <div><Button onClick={this.props.onSuccess}>Continue</Button></div>
                }
                if (data.washpirg_sw !== "Y") {
                    form =
                        <>
                            <p>It is past the deadline to make a contribution to WashPIRG.</p>
                            <p>No, I am not contributing to WashPIRG.</p>
                            {nextButton}
                        </>
                } else {
                    form =
                        <>
                            <p>It is past the deadline to change your contribution to WashPIRG.</p>
                            <p>Yes, I am contributing ${amount} to WashPIRG.</p>
                            {nextButton}
                        </>
                }
            } else {
                let disableButton = formData.WPG !== "Y" && formData.WPG !== "N";
                form =
                    <Form onSubmit={this.submitForm}>
                        <fieldset>
                            <legend className="h3">WashPIRG contribution:</legend>
                            <Form.Check
                                label={`Yes, add $${amount} for WashPIRG to my bill`}
                                name="WPG"
                                type="radio"
                                value="Y"
                                defaultChecked={formData.WPG === "Y"}
                                onChange={this.handleChange}
                                id="wpg-yes"
                            />
                            <Form.Check
                                label={`No`}
                                name="WPG"
                                type="radio"
                                value="N"
                                defaultChecked={formData.WPG === "N"}
                                onChange={this.handleChange}
                                id="wpg-no"
                            />
                        </fieldset>
                        <Button aria-disabled={disableButton} type="submit" className={classnames({"disabled": disableButton})}>Continue</Button>
                    </Form>
            }

            return (
                <>
                    <h4 className="h2">WashPIRG</h4>
                    <p>
                        <a href='https://www.washpirgstudents.org/uw' target='_blank'>Washington Public Interest Research Group (WashPIRG)</a> is a voluntary,
                        student-directed, non-profit and non-partisan organization which works on issues affecting the quality of life in Washington state around
                        consumer, environmental and governmental issues. If you choose to contribute to WashPIRG, ${amount} will be included on your tuition-billing
                        statement. Additional information may be obtained by contacting the Student Activities Office in the HUB or
                        through <a href='https://www.washpirgstudents.org/uw' target='_blank'>WashPIRG's website</a>.
                    </p>
                    {form}
                </>
            );
        }
    }
}

OpChargeWashPIRG.propTypes = {
    campus: PropTypes.string.isRequired,
    showButton: PropTypes.bool
}

OpChargeWashPIRG.defaultProps = {
    showButton: false
}

export default observer(OpChargeWashPIRG);